/**
 * @file  首页
 * @create macaiqi 2025/04/28
 * @update
 */
import React, { useState } from "react";
import qsgshade from "../../assets/images/shade-qsg.png";
import yzqfshade from "../../assets/images/shade-yzqf.png";
import zqfshade from "../../assets/images/shade-zqf.png";
import tqsxshade from "../../assets/images/shade-tqsx.png";
import mqxshade from "../../assets/images/shade-mqx.png";
import yzqsshade from "../../assets/images/shade-yzqs.png";
import slmqgshade from "../../assets/images/shade-slmqg.png";
import homebg from "../../assets/images/homebg.jpg";
import QSGPage from "../QSG";
import YZQFPage from "../YZQF";
import ZQFPage from "../ZQF";
import TQSXPage from "../TQSX";
import MQXPage from "../MQX";
import YZQSPage from "../YZQS";
import SLMQGPage from "../SLMQG";
import cls from "classnames";
import "animate.css";
import "./home.scss";

// 统一配置管理
const CONFIG = {
  qsg: {
    img: qsgshade,
    page: "qsgpage",
    component: QSGPage,
    btnClass: "qsg",
  },
  yzqf: {
    img: yzqfshade,
    page: "yzqfpage",
    component: YZQFPage,
    btnClass: "yzqf",
  },
  zqf: {
    img: zqfshade,
    page: "zqfpage",
    component: ZQFPage,
    btnClass: "zqf",
  },
  tqsx: {
    img: tqsxshade,
    page: "tqsxpage",
    component: TQSXPage,
    btnClass: "tqsx",
  },
  mqx: {
    img: mqxshade,
    page: "mqxpage",
    component: MQXPage,
    btnClass: "mqx",
  },
  yzqs: {
    img: yzqsshade,
    page: "yzqspage",
    component: YZQSPage,
    btnClass: "yzqs",
  },
  slmqg: {
    img: slmqgshade,
    page: "slmqgpage",
    component: SLMQGPage,
    btnClass: "slmqg",
  },
};

function Shade({ show, onClose, onGo }) {
  const currentConfig = CONFIG[show];
  if (!currentConfig) return null;

  return (
    <div className="shade animate__animated animate__fadeIn">
      <i className="close" onClick={onClose}></i>
      <img src={currentConfig.img} alt="" />
      <i className="go" onClick={onGo}></i>
    </div>
  );
}

export default function Home() {
  const [show, setShow] = useState();
  const [toPage, setToPage] = useState();

  // 动态渲染目标页面
  const renderPage = () => {
    const pageConfig = Object.values(CONFIG).find(
      (config) => config.page === toPage,
    );
    if (!pageConfig) return null;
    const PageComponent = pageConfig.component;
    return <PageComponent setToPage={setToPage} />;
  };

  return (
    <>
      <div className={"home-page "}>
        <div className="bgbox">
          <img src={homebg} alt="" srcset="" />
          <div className="homelogo"></div>
          <div
            className="zstplink"
            onClick={() => {
              window.open(window.ZSTPLINK);
            }}
          ></div>

          {Object.keys(CONFIG).map((key) => (
            <div
              key={key}
              className={cls(
                `${CONFIG[key].btnClass} btn animate__animated animate__pulse animate__slow animate__infinite`,
                { active: show === key },
              )}
              onClick={() => {
                setShow(key);
              }}
            />
          ))}

          {show && (
            <Shade
              show={show}
              onClose={() => setShow(null)}
              onGo={() => {
                setToPage(CONFIG[show].page);
                setShow(null);
              }}
            />
          )}
        </div>
      </div>
      {renderPage()}
    </>
  );
}
